<template>
  <nav v-if="listCount > 0">
    <b-pagination
      size="sm"
      :prev-text="$t('PREV')"
      :next-text="$t('NEXT')"
      :total-rows="listCount"
      :per-page="perPage"
      v-model="currentPage">
    </b-pagination>
  </nav>
</template>

<script>
    export default {
        name: "ApplicantPagination",
        computed: {
        filter() {
          return this.$store.getters['applicant/getSearchFilter']
        },
        listCount() {
          return this.$store.getters['applicant/getSearchListCount']
        },
        perPage() {
          return this.filter.limit
        },
        currentPage: {
          get() {
            return this.filter.page
          },
          set(value) {
            this.$store.commit('applicant/setSearchFilterItem', {item: 'page', value})
            this.$store.dispatch('applicant/actionSearch')
          }
        }
      }
    }
</script>

<style scoped>

</style>
